import { appSync, startListening } from '@bonanza-social/toolkit/state';
import { fetchDailyRewards } from './dailyRewards.slice';

startListening({
  actionCreator: appSync,
  effect: (_, { dispatch }) => {
    dispatch(fetchDailyRewards());
  },
});
